/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import Button from 'components/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import { MdOutlineWarning } from 'react-icons/md';
import { EarlyPayoutRequestResult } from 'legacy/events/types';

const getResultMessage = (result: EarlyPayoutRequestResult | undefined) => {
  switch (result) {
    case EarlyPayoutRequestResult.NOT_HOST:
      return 'You must be the event host to initiate an Early Payout.';
    case EarlyPayoutRequestResult.ORG_USER_NOT_MEMBER:
      return 'You must be a member of the Verified+ organization to initiate Early Payouts.';
    case EarlyPayoutRequestResult.ORG_EARLY_PAYOUTS_DENIED:
      return 'Early Payouts are disabled for your organization.';
    case EarlyPayoutRequestResult.EVENT_ENDED:
      return 'Early Payouts can only be initiated before an event ends.';
    case EarlyPayoutRequestResult.EVENT_WITH_PROMOTERS:
      return 'Events with Promoter Offers are currently not eligible for early payouts.';
    default:
      return '';
  }
};

const EarlyPayoutsErrorModal = ({
  open,
  onClose,
  result
}: {
  open: boolean;
  onClose?: () => void;
  result: EarlyPayoutRequestResult | undefined;
}) => (
  <Modal
    visible={open}
    title="Early Payout Failed"
    icon={<MdOutlineWarning size={20} />}
    iconVariant="danger"
    type={ModalType.ALERT}
    onClose={onClose}
  >
    <div className="flex flex-col px-4 pt-6">
      <p>
        {getResultMessage(result)}
        <Button className="w-full" variant="secondary" onClick={onClose}>
          OK
        </Button>
      </p>
    </div>
  </Modal>
);

export default EarlyPayoutsErrorModal;
